import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { ShieldAlert } from 'lucide-react';

/**
 * Tek-oturum güvenlik bildirimi — başka bir cihazdan login yapıldığında
 * mevcut oturumu nazikçe kapatır. Kullanıcıya 5 saniyelik bir geri sayım
 * gösterilir, "Şimdi çık" butonu da var.
 */
export function ForceLogoutModal({ reason, onAck }: { reason: string; onAck: () => void }) {
  const [secs, setSecs] = useState(5);
  useEffect(() => {
    const t = setInterval(() => setSecs((s) => Math.max(0, s - 1)), 1000);
    return () => clearInterval(t);
  }, []);
  useEffect(() => {
    if (secs === 0) onAck();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [secs]);

  const reasonText = reason === 'new_session' || reason === 'replaced'
    ? 'Hesabınız başka bir cihazdan açıldı. Güvenliğiniz için bu oturum kapatıldı.'
    : 'Oturumunuz sunucu tarafından sonlandırıldı.';

  return createPortal(
    <div
      style={{ position: 'fixed', inset: 0, zIndex: 99999 }}
      className="bg-slate-950/80 backdrop-blur-md flex items-center justify-center p-4 animate-[fadeIn_0.2s_ease]"
    >
      <div className="bg-surface rounded-3xl shadow-2xl w-full max-w-md p-6 ring-1 ring-black/10 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-amber-400 to-amber-600 text-[#08140d] shadow-[0_8px_24px_-6px_rgba(245,158,11,0.55)] mb-4">
          <ShieldAlert size={28} strokeWidth={2.25} />
        </div>
        <h2 className="text-[20px] font-semibold text-slate-900 tracking-tight mb-2">
          Oturumun sonlandı
        </h2>
        <p className="text-[13.5px] text-slate-600 leading-snug mb-5">
          {reasonText}
        </p>
        <button
          onClick={onAck}
          className="w-full py-2.5 rounded-xl bg-gradient-to-br from-brand-500 to-brand-600 hover:from-brand-400 hover:to-brand-700 text-[#08140d] text-sm font-semibold shadow-[0_6px_16px_-4px_rgba(255,79,31,0.5)] transition active:scale-[0.98]"
        >
          Şimdi çık {secs > 0 ? <span className="font-mono opacity-70 ml-1">({secs})</span> : null}
        </button>
      </div>
    </div>,
    document.body,
  );
}
